module.exports = __webpack_public_path__ + "static/media/girls_hair.36704393.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand/girls_hair.png
// module id = 151
// module chunks = 0